/**
 * Schach Manufaktur — scroll reveal.
 *
 * Elements marked `data-luxe-reveal` fade and rise into place once. The hiding
 * CSS is gated behind the `luxe-reveal-ready` class, which is only added here —
 * so if this script never runs, nothing is ever hidden.
 */
(function () {
  const REVEAL_SELECTOR = '[data-luxe-reveal]';
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (prefersReducedMotion.matches || !('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('luxe-reveal-ready');

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
  );

  /**
   * Staggers children within a group so a row of cards cascades instead of
   * snapping in together. Index is scoped per group, not per page.
   */
  function observe(root) {
    const groups = new Map();

    for (const el of root.querySelectorAll(REVEAL_SELECTOR)) {
      if (el.dataset.luxeRevealBound) continue;
      el.dataset.luxeRevealBound = 'true';

      const group = el.closest('[data-luxe-reveal-group]');
      if (group) {
        const index = groups.get(group) ?? 0;
        groups.set(group, index + 1);
        el.style.setProperty('--luxe-reveal-delay', `${index * 90}ms`);
      }

      observer.observe(el);
    }
  }

  observe(document);

  // The theme editor swaps section markup in place; re-scan what it inserts.
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) observe(event.target);
  });

  // Reduced-motion can be toggled mid-session; reveal everything if it is.
  prefersReducedMotion.addEventListener('change', (event) => {
    if (!event.matches) return;
    observer.disconnect();
    for (const el of document.querySelectorAll(REVEAL_SELECTOR)) el.classList.add('is-revealed');
  });
})();
